import React from 'react'

import { SelectDocumentType } from './v2/screens/select-document-type'

export function TenantDocuments() {
  return <SelectDocumentType />
}
